module.exports = __webpack_public_path__ + "img/huanhuo1_pc.46dcf1e.jpg";